<fieldset [formGroup]="formTitle" class="form-group" [ngClass]="{'is-invalid': hasTitleNotSelected}">
  <label>Title</label>
  <div class="c-radio--group title-buttons">
    @for (t of titles; track t) {
      <span class="c-radio-button">
        <input id="title-button-{{t}}-{{instanceId}}" type="radio" name="titleButton" formControlName="titleButton" value="{{t}}">
        <label class="c-radio-button__label" for="title-button-{{t}}-{{instanceId}}">
          <span class="c-radio-button__faux">{{t}}</span>
        </label>
      </span>
    }
  </div>
  <div class="c-radio--list custom-controls-stacked title-list">
    @for (t of titles; track t) {
      <span class="c-radio-button">
        <label class="custom-control custom-radio">
          <input id="title-list-{{t}}-{{instanceId}}" type="radio" class="custom-control-input" name="titleList" formControlName="titleList" value="{{t}}">
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">{{t}}</span>
        </label>
      </span>
    }
  </div>
  <together-auction-dip-validate-fields [displayError]="hasTitleNotSelected" errorMsg="Please choose a title"></together-auction-dip-validate-fields>
</fieldset>
